export const footerData = () => {
  return [
    {
      url: "https://www.mlb.com/cubs/tickets",
      title: "Tickets",
    },
    {
      url: "https://www.mlb.com/cubs/fans/weekly-highlights",
      title: "Highlights",
    },
    {
      url: "https://www.mlb.com/cubs/schedule/2021-02",
      title: "Schedule",
    },
    {
      url: "https://www.mlb.com/cubs/scores/2021-02-26",
      title: "Scores",
    },
    {
      url: "https://www.mlb.com/cubs/standings",
      title: "Standings",
    },
    {
      url: "https://www.mlb.com/cubs/stats/",
      title: "Stats",
    },
    {
      url: "https://www.mlb.com/cubs/roster",
      title: "Roster",
    },
  ];
};
